import React from 'react';
import { BookOpen, FileText, Scale } from 'lucide-react';

export const EMPTY_CHAT_HEADING = 'What would you like to explore?';

const PROMPT_SHORTCUTS = [
  {
    title: 'Understand a regulation',
    description: 'Turn complex guidance into clear answers.',
    prompt: 'Explain this regulation in plain language and what it means for billing.',
    icon: FileText,
  },
  {
    title: 'Compare policies',
    description: 'Explore differences across your sources.',
    prompt: 'Compare these policies and explain the differences that matter.',
    icon: Scale,
  },
  {
    title: 'Find trusted guidance',
    description: 'Start with the knowledge in your library.',
    prompt: 'Find trusted guidance in the library on this topic.',
    icon: BookOpen,
  },
] as const;

/** Empty Ask screen: heading, composer, and local prompt shortcuts. */
export function ChatEmptyState({
  children,
  onSelectPrompt,
}: {
  children: React.ReactNode;
  onSelectPrompt?: (prompt: string) => void;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto bg-[var(--rcm-color-canvas)]">
      <div className="mx-auto flex w-full max-w-[960px] flex-1 flex-col justify-center px-5 py-8 pb-[10vh] md:px-8">
        <h1 className="mb-8 text-center text-[30px] font-semibold leading-tight tracking-tight text-[var(--rcm-color-text)] md:text-[32px]">
          {EMPTY_CHAT_HEADING}
        </h1>

        {children}

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {PROMPT_SHORTCUTS.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.title}
                type="button"
                className="rounded-2xl border border-[var(--rcm-color-border)] bg-[var(--rcm-color-surface)] p-5 text-left transition-colors hover:bg-[var(--rcm-color-sidebar)]"
                onClick={() => {
                  onSelectPrompt?.(item.prompt);
                  requestAnimationFrame(() => {
                    document.getElementById('ask-composer')?.focus();
                  });
                }}
              >
                <Icon className="mb-4 h-5 w-5 text-[var(--rcm-color-text-secondary)]" strokeWidth={1.75} aria-hidden />
                <span className="block text-[15px] font-semibold text-foreground">{item.title}</span>
                <span className="mt-1 block text-sm leading-snug text-[var(--rcm-color-text-secondary)]">
                  {item.description}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
